import React from 'react';
import { SnomedEntry, vitalCodeMap } from 'model/toolbar/snomed';
import IsUsedWithToolbar from 'components/Toolbar/Enabled';
import {
  SnomedListItemContainer,
  SnomedToggle,
  SnomedData,
} from './styles';

interface SnomedCodeListItemProps {
  snomedCode: SnomedEntry;
  handleToggle: (code: string) => void;
  isToggled: boolean;
  isAiSnomed?: boolean;
}

const SnomedCodeListItem: React.FC<SnomedCodeListItemProps> = ({
  snomedCode,
  handleToggle,
  isToggled,
  isAiSnomed = false,
}) => {
  const snomedUnit = snomedCode.code === vitalCodeMap.bmi.code ? 'kg/m2' : snomedCode.unit; // clean bmi as emis/s1 look different
  return (
    <SnomedListItemContainer data-automation="snomedListItemContainer" isAiSnomed={isAiSnomed}>
      <IsUsedWithToolbar>
        <SnomedToggle
          onClick={() => handleToggle(snomedCode.code)}
          isChecked={isToggled}
          labelHidden
          id={snomedCode.code}
          label={snomedCode.code}
        />
      </IsUsedWithToolbar>
      <SnomedData data-automation="snomedCode">
        {snomedCode.code}
      </SnomedData>
      <SnomedData data-automation="snomedDescription">
        {snomedCode.info}
      </SnomedData>
      {snomedCode.unit && snomedCode.value && (
        <SnomedData data-automation="snomedValueUnit">
          {snomedCode.value} {snomedUnit}
        </SnomedData>
      )}
    </SnomedListItemContainer>
  );
};

SnomedCodeListItem.defaultProps = {
  isAiSnomed: false,
};

export default SnomedCodeListItem;
